import "../css/TeeStyles.css";
import React from "react";
import clapperBoard from "../icons/assets/clapperboard.png";
import { HorizontalScroll, HoverImages } from "./smallComponents/listIconText";
import film from "../icons/assets/film.png";
import radio from "../icons/assets/Radio.png";
import imgOne from "../icons/assets/img-1.png";
import imgTwo from "../icons/assets/img-2.png";
import imgThree from "../icons/assets/img-3.png";
import imgFour from "../icons/assets/img-4.png";
import imgFive from "../icons/assets/img-5.png";
import imgSix from "../icons/assets/img-6.png";
import imgSeven from "../icons/assets/img-7.png";

const images = [
  {
    img: imgOne,
    text: "A Broadcast session with Jobs Lounge",
  },
  {
    img: imgTwo,
    text: "Exclusive Podcast session with HRTV",
  },
  {
    img: imgThree,
    text: "Use our Chroma backdrop for your shoot ",
  },
  {
    img: imgFour,
    text: " Photoshoot with steeze ",
  },
  {
    img: imgFive,
    text: "Capture the moment ",
  },
  {
    img: imgSix,
    text: "Let's make memories together ",
  },
];
interface hoverList {
  img: any;
  text: String;
}

const imagesObject = images.map((img, i) => ({
  id: i,
  img: img.img,
  text: img.text,
}));

const SectionThree: React.FC = () => {
  return (
    <div
      className="bgWhite section py-5 px-md-4 px-0 position-relative"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="900"
    >
      <span className="fontSize34px boldSeven blackKsb d-block text-center mb-4">
        EXPLORE OUR WORK
      </span>
      <span className="fontSize15px wid100Mobile wid55 mx-auto boldSeven d-block px-3 px-md-0 text-center blackKsb">
        Dive into our most recent work that exemplifies our commitment to
        quality and innovation. These projects represent the forefront of our
        creative endeavors.
      </span>
      <img
        src={clapperBoard}
        className="position-absolute"
        alt=""
        style={{ top: "25%" }}
      />
      <img
        src={film}
        className="position-absolute"
        alt=""
        style={{ top: "15%", right: "15%" }}
      />
      <div className="d-md-flex wid80 mx-auto d-none mt-5 justify-content-center flex-wrap">
        {/* <img src={imgOne} alt="" />
        <img src={imgTwo} alt="" />
        <img src={imgThree} alt="" />
        <img src={imgFour} alt="" className="mt-3" />
        <img src={imgFive} alt="" className="mt-3" />
        <img src={imgSix} alt="" className="mt-3" /> */}
        {<HoverImages images={imagesObject} />}
      </div>
      {<HorizontalScroll images={images} />}
      <img
        src={radio}
        className="position-absolute"
        alt=""
        style={{ bottom: "0%", right: "15%" }}
      />
    </div>
  );
};

export default SectionThree;
